export const darkBlue = "#005470";
export const hoverBlue = "#00435A";
export const disabledGrey = "#0000001F";

export const confirmButtonColor = "#005470";

export const red = "#FF0000";
export const black = "#000000";
export const grey = "#666666";
export const white = "#FFFFFF";

export const boxGrey = "#F2F4F6";
export const borderGrey = "#E0E0E0";
